// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAGVfqLg6zy2EgxMB-zDhYAwmik7wSB41A",
    authDomain: "cms-data-alpha.firebaseapp.com",
    projectId: "cms-data-alpha",
    storageBucket: "cms-data-alpha.firebasestorage.app",
    messagingSenderId: "1033866554321",
    appId: "1:1033866554321:web:0c9d100374fe89308bcef0",
    measurementId: "G-BPT6YZ8QK5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { app, analytics, db };